import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";

import {
    templateAuthorRelayFragment$data,
    templateAuthorRelayFragment$key
} from "@/__generated__/templateAuthorRelayFragment.graphql";
import { ConfluenceTemplateMessages } from "@/components/confluence/templates/template-messages";

interface TemplateAuthorProps {
    template: templateAuthorRelayFragment$key;
}

const templateAuthor = css({
    fontSize: "0.75rem",
    lineHeight: "1.3125rem",
    fontWeight: 500,
    // FIXME: GWP-3063: Disabling instead of fixing so we don't deviate from the control visually.
    // eslint-disable-next-line local/ensure-wac-token-usage
    color: "#0052CC",
    // FIXME: GWP-3063: Disabling instead of fixing so we don't deviate from the control visually.
    // eslint-disable-next-line local/ensure-wac-token-usage
    fontFamily: "var(--bxp-charlie-display-font-family)",
    margin: 0,
    marginBlockEnd: "24px",
    textTransform: "uppercase"
});

const isAuthor = (
    contributor: templateAuthorRelayFragment$data["contributor"]
) => contributor?.__typename === "ContentPlatformAuthor";

const isOrganization = (
    contributor: templateAuthorRelayFragment$data["contributor"]
) => contributor?.__typename === "ContentPlatformOrganization";

const TemplateAuthorRelayFragment = graphql`
    fragment templateAuthorRelayFragment on ContentPlatformTemplate {
        contributor {
            __typename
            ... on ContentPlatformAuthor {
                name
                jobTitle
                organization {
                    name
                }
            }
            ... on ContentPlatformOrganization {
                name
            }
        }
    }
`;

export const TemplateAuthor = ({ template }: TemplateAuthorProps) => {
    const { contributor } = useFragment(TemplateAuthorRelayFragment, template);

    let contributorName =
        ((isAuthor(contributor) || isOrganization(contributor)) &&
            contributor.name) ||
        undefined;

    const author = isAuthor(contributor) ? contributor : null;

    let authorDetail = author?.jobTitle;
    if (authorDetail && author?.organization?.name) {
        authorDetail = `${authorDetail} @ ${author.organization.name}`;
    }

    if (authorDetail) {
        contributorName = `${contributorName}, (${authorDetail})`;
    }

    return (
        contributorName && (
            <h3 css={templateAuthor}>
                <FormattedMessage
                    {...ConfluenceTemplateMessages.templateAuthorByLine}
                    values={{
                        author: contributorName
                    }}
                />
            </h3>
        )
    );
};
